import React, { useContext, useEffect } from 'react';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import CaseListDropDown from 'components/CaseListDropDown/CaseListDropDown';
import { UserDetailsContext } from 'context/userDetailsContext';
import { convertCaseToFilterFormat } from 'utils/utils';

function CaseFilter() {
  const { fileManagerFilters, onFilterChange, isClientFileManager, setBreadCrumbs, setSelectedRows } = useFileManagerContext();
  const userContext = useContext(UserDetailsContext);

  const caseFilterValue = convertCaseToFilterFormat(userContext?.clientSelectedCase) || '';

  function clearBreadcrumbs() {
    setBreadCrumbs([]);
  }

  const handleFilterChange = (e) => {
    if (fileManagerFilters?.case !== e) {
      onFilterChange({ target: { name: 'case', value: e }, value: e }, clearBreadcrumbs);
      setSelectedRows([]);
    }
  };

  useEffect(() => {
    // Only set the filter if:
    // 1. It's client file manager
    // 2. clientSelectedCase exists
    // 3. No case is currently selected in filters (to prevent overriding user selection)
    if (isClientFileManager && userContext?.clientSelectedCase && !fileManagerFilters?.case?.id) {
      onFilterChange(
        {
          target: {
            name: 'case',
            value: caseFilterValue,
          },
          value: caseFilterValue,
        },
        setBreadCrumbs
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext?.clientSelectedCase, isClientFileManager, fileManagerFilters?.case?.id]);

  return (
    <div className="filter-wraper">
      {isClientFileManager && userContext?.clientCaseList?.length > 1 && (
        <CaseListDropDown
          isClient={isClientFileManager}
          value={fileManagerFilters?.case}
          onChange={handleFilterChange}
          name="case"
          selectFirstOption
          excludeFromLoading={true}
        />
      )}
    </div>
  );
}

export default CaseFilter;
